// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: 32px;
  /*
  margin-left: 128px;
  flex-shrink: 0;
  min-width: 1440px;
  height: 100%;
  */
  background: var(--Colors-UI-Neutral-Grey-100, #F5F5F5);

  /* make the main page content scroll vertically */
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/page.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ;;;;;GAKC;EACD,sDAAsD;;EAEtD,iDAAiD;EACjD,cAAc;AAChB","sourcesContent":["@import url(\"./global.css\");\n\n:host {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 32px;\n  /*\n  margin-left: 128px;\n  flex-shrink: 0;\n  min-width: 1440px;\n  height: 100%;\n  */\n  background: var(--Colors-UI-Neutral-Grey-100, #F5F5F5);\n\n  /* make the main page content scroll vertically */\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
